import React, { useState } from 'react'
import {
  Button,
  Card,
  CardContent as MuiCardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material'
import styled from 'styled-components';

interface UserQuantityDialogProps {
  onConfirm: (quantity: number) => void;
  onCancel: () => void;
  defaultQuantity: number;
  unitPrice?: number;
  interval?: string;
  visible: boolean;
}

const UserQuantityDialog: React.FC<UserQuantityDialogProps> = ({
  onConfirm,
  onCancel,
  defaultQuantity,
  unitPrice,
  interval,
  visible,
}) => {
  const [quantity, setQuantity] = useState<number>(defaultQuantity);

  const intervalText = (typeof interval == 'string') ? ` per ${interval}` : '';
  const priceText = (typeof unitPrice == 'number' && typeof quantity == 'number' && !isNaN(quantity)) ? `Billing will be $${quantity * unitPrice}${intervalText}` : null;

  return (
    <Dialog
      open={visible}
      onClose={onCancel}
    >
      <DialogTitle>Number of users</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter the number of users to be covered in your subscription.
          {(priceText != null) && (
            <><br/>{priceText}</>
          )}
        </DialogContentText>
        <TextField
          autoFocus
          required
          margin="dense"
          id="quantity"
          name="quantity"
          type="number"
          value={isNaN(quantity) ? '' : quantity}
          onChange={(event) => {
            try {
              const newVal = parseInt(event.target.value);
              setQuantity(Math.min(Math.max(newVal, 1), 99));
            } catch(error) {
              console.error(error)
            }
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          type="submit"
          onClick={() => {
            if (isNaN(quantity)) {
              return;
            }
            onConfirm(quantity)
          }}
        >Continue</Button>
      </DialogActions>
    </Dialog>
  );
}

export default UserQuantityDialog;
